/** This mixin allows the getEventDate method to be called from different places on the app
 * @mixin */

export default {
  methods: {
    getEventDate() {
      // for some reason, the datepicker will add the offset hours to the time we pass in
      // so we remove those hours first in order to pass the correct local time to the backend
      // There are several issues about this:
      // https://github.com/charliekassel/vuejs-datepicker/issues/585
      // https://github.com/charliekassel/vuejs-datepicker/issues/666
      const eventDateTimeLocal = new Date();
      const offsetHours = eventDateTimeLocal.getTimezoneOffset() / 60;
      eventDateTimeLocal.setHours(eventDateTimeLocal.getHours() - offsetHours);
      return eventDateTimeLocal;
    },
  },
};
